// extracted by mini-css-extract-plugin
export default {"container":"style_container__xRzY5","header":"style_header__mDY3n"};